import produce from "immer";
import { IGambit, IState } from "../types";
import { IReducerAction } from "./types";

function swapGambitsReducer(state: IState, action: IReducerAction): IState {
  if (action.payload === undefined) return state;
  if (!("order" in action.payload)) return state;
  const { index, order, otherOrder } = action.payload;
  const { actors, ...stateProps } = state;
  return {
    ...stateProps,
    actors: produce(actors, draft => {
      const tmp = draft[index].gambits[order];
      draft[index].gambits[order] = draft[index].gambits[otherOrder];
      draft[index].gambits[otherOrder] = tmp;
    })
  };
}

function updateGambitReducer(state: IState, action: IReducerAction): IState {
  if (action.payload === undefined) return state;
  if (!("condition" in action.payload)) return state;
  const { actors, pick, ...stateProps } = state;
  const newGambit = action.payload;

  return {
    ...stateProps,
    pick: { ...state.pick, gambit: undefined },
    screen: "#battle",
    actors: produce(actors, draft => {
      if (pick.gambit === undefined) return;
      draft[pick.gambit.actorIndex].gambits[pick.gambit.index] = newGambit;
    })
  };
}

function activateGambitReducer(state: IState, action: IReducerAction): IState {
  if (action.payload === undefined) return state;
  if (!("id" in action.payload && "index" in action.payload)) return state;
  const { index, id } = action.payload;
  const { actors, ...stateProps } = state;
  return {
    ...stateProps,
    actors: produce(actors, draft => {
      const pickedGambit = draft[index].gambits.find(
        (gambit: IGambit) => gambit.id === id
      );
      if (!pickedGambit) return;
      pickedGambit.active = !pickedGambit.active;
    })
  };
}

function changeGambitReducer(state: IState, action: IReducerAction): IState {
  if (action.payload === undefined) return state;
  if (!("id" in action.payload && "index" in action.payload)) return state;
  const { index: actorIndex, id } = action.payload;
  const { actors } = state;
  const gambitIndex = actors[actorIndex].gambits.findIndex(
    (gambit: IGambit) => gambit.id === id
  );
  if (gambitIndex === undefined) return state;
  return {
    ...state,
    screen: "#gambit_selection",
    pick: { ...state.pick, gambit: { actorIndex, index: gambitIndex } }
  };
}

export {
  changeGambitReducer,
  updateGambitReducer,
  swapGambitsReducer,
  activateGambitReducer
};
